<template>
	<div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">财务明细</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">财务明细</div>
      </div>
      <div class="panel-body clearfix">
        <div class="Z-hr"></div>
        <div class="block">
          <span class="demonstration">起止时间：</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
          &nbsp;&nbsp;&nbsp;
          <span>交易类型：</span>
          <el-select v-model="trade" placeholder="全部" style="width: 90px;">
            <el-option
              v-for="item in selects"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="z-display-inlineBlock">
            <xbutton type="search" font="查询" class="z-border-all-grey" @XbuttonService="SearchCaiwu"/>
          </div>
        </div>
        <!--列表-->
        <el-table :data="userList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="id" label="序号" align="center" >
          </el-table-column>
          <el-table-column prop="shouru" label="收入(+)"  align="center" width="170">
            <template slot-scope="scope">
              <span v-if="scope.row.caiwu_type === '收入'" class="z-color-66-orange">
                <span style="width: 65px;display: inline-block;text-align: right">{{ scope.row.caiwu_money }} 元</span>
                丨
                <span style="width: 65px;display: inline-block;text-align: left">{{scope.row.income_type}}</span>
              </span>
              <span v-if="scope.row.caiwu_type === '支出'" class="z-color-66-orange">--</span>
            </template>
          </el-table-column>
          <el-table-column prop="shouru" label="支出(-)"  align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.caiwu_type === '支出'">{{ scope.row.caiwu_money }} 元</span>
              <span v-if="scope.row.caiwu_type === '收入'">--</span>
              <el-popover trigger="hover">
                <p>其中使用优惠券({{ scope.row.yhq_id }})</p>
                <p style="text-align: center">消费{{ scope.row.yhq_cost }}</p>
                <span slot="reference" class="name-wrapper" style="color: #ff9832">
                  {{ scope.row.yhq }}
                </span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="left_money" label="余额" align="center">
            <template slot-scope="scope">
              <span class="z-color-66-orange">{{ scope.row.left_money }} 元</span>
            </template>
          </el-table-column>
          <el-table-column prop="caiwu_time" label="交易日期" align="center">
            <template slot-scope="scope">
              <span class="z-color-muted">{{ scope.row.caiwu_time }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cost_type" label="消费类型" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip align="center">
          </el-table-column>

        </el-table>
        <el-pagination background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <div style="margin-top: 32px;float: left">总收入：<span class="z-color-a">{{allmoney.total_money_in}}</span>&nbsp;&nbsp;总支出： <span class="z-color-a">{{allmoney.total_money_out}}</span></div>
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>


      </div>
    </div>
	</div>
</template>
<script>
  import Xtable from 'components/commons/Xtable.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import caiwuService from 'business/caiwuService.js'
export default {
  data() {
    return {
      userList: [],
      allmoney:{},
      selects: [{
        value: '',
        label: '全部'
      },{
        value: '0',
        label: '支出'
      }, {
        value: '1',
        label: '收入'
      }],
      trade: '',
      listLoading:false,
      count: 10,
      total: 0,
      page: 1,
      date: []
    }
  },
  components:{
    Xtable,
    Xbutton,
  },
  props:{
    hide:Boolean
  },
  mounted() {
    this.SearchCaiwu()
  },
  methods:{
    async SearchCaiwu() {
      this.listLoading = true
      let date0 = this.date[0] ? this.date[0] : ''
      let date1 = this.date[1] ? this.date[1] : ''
      let data = 'cmd=caiwu_list'+'&count='+ this.count +'&page='+ this.page +'&caiwu_type='+this.trade+'&caiwu_time_1='+date0+'&caiwu_time_2='+date1
      let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
      if(vueData.response == 200 ) {
        this.total = vueData.data.allcount
        let curpage = vueData.data.curpage
        this.userList = vueData.data.content.map((item, index) => {
          return {
            id:String(curpage * 10 + index - 9 ),
            caiwu_type:item.caiwu_type,
            income_type:item.income_type,
            cost_type:item.cost_type,
            caiwu_money:item.caiwu_money,
            caiwu_time:item.caiwu_time,
            remark:item.remark,
            left_money:item.left_money,
            yhq_id:item.yhq_id,
            yhq:item.yhq_id == 0 ? '' : '优惠券',
            yhq_cost:item.yhq_cost
          }
        })
        this.allmoney = vueData.allmoney
        this.listLoading = false
      }else {
        this.$toast(vueData.msg,'fail')
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.SearchCaiwu()
    },
    handleSizeChange(val) {
      this.count = val
      this.SearchCaiwu()
    },
  }
}
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
</style>



// WEBPACK FOOTER //
// src/pages/caiwu/caiwu1.vue